import { render, staticRenderFns } from "./loanchargesreport.vue?vue&type=template&id=ab32872a"
import script from "./loanchargesreport.vue?vue&type=script&lang=js"
export * from "./loanchargesreport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports